<ngx-qrcode
  [elementType]="elementType"
  [value]="pointIdUrl"
  [errorCorrectionLevel]="errorCorrectionLevel"
  [margin]="margin"
  [width]="width"
  [scale]="scale"
  [cssClass]="cssClass"
  >
</ngx-qrcode>